/**
 * Vertical timeline / swimlane strip of execution nodes.
 */
import React from 'react';
import { nodeStatusForDisplay } from '@/utils/traceModel';
import { GitBranch, Circle } from 'lucide-react';

export default function TraceTimeline({ nodes, selectedId, onSelect, compact }) {
  if (!nodes.length) {
    return (
      <div className="h-full flex flex-col items-center justify-center p-6 text-center text-gray-500 text-sm">
        <GitBranch className="w-10 h-10 text-gray-300 mb-2" />
        <p className="font-medium text-gray-700">No trace events yet</p>
        <p className="text-xs mt-1 max-w-[14rem]">
          Run the network or merge S3 logs after execution. Structured worker logs appear here.
        </p>
      </div>
    );
  }

  return (
    <div className={`h-full overflow-y-auto ${compact ? 'py-2' : 'py-3'} px-2 space-y-1`}>
      {nodes.map((node, idx) => {
        const st = nodeStatusForDisplay(node);
        const selected = selectedId === node.id;
        return (
          <button
            key={node.id}
            type="button"
            onClick={() => onSelect(node.id)}
            className={`w-full text-left rounded-xl border transition-all ${
              selected
                ? 'border-blue-400 ring-2 ring-blue-100 bg-blue-50/80 shadow-sm'
                : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50/80'
            }`}
          >
            <div className="flex gap-2 p-2.5">
              <div className="flex flex-col items-center pt-0.5">
                <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${st.dot}`} title={st.label} />
                {idx < nodes.length - 1 && <span className="w-px flex-1 min-h-[12px] bg-gray-200 mt-1" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1.5">
                  <Circle className="w-3.5 h-3.5 text-gray-400 shrink-0" />
                  <span className="text-sm font-medium text-gray-900 truncate">{node.title}</span>
                </div>
                {node.subtitle && (
                  <p className="text-[11px] text-gray-500 truncate mt-0.5">{node.subtitle}</p>
                )}
                <p className="text-[10px] text-gray-400 mt-1">
                  {node.firstTs && new Date(node.firstTs).toLocaleTimeString()}
                </p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
